import {action, makeAutoObservable} from "mobx"
import {RootStore} from "../index";
import LogModel from "../../model/LogModel";
import {ISelect} from "../../interface/ISelect";
import Request1cModel from "../../model/Request1cModel";
import UserModel from "../../model/UserModel";

export class PageAdminUserLogStore {
    private rootStore: RootStore | undefined;

    public arData = [];


    public error: string = '';

    public isErrorFilter:boolean =false;


    limitRow = 10;

    pagination = {
        countPage: 1,
        countRow: 1,
        currentPage: 1
    }
    private search: string = '';


    public cityOption: ISelect[] = [];
    public citySelected: ISelect = {
        label: 'Введите пользователя',
        value: ''
    };

    public cityError = '';


    @action
    onInputSelectChangeCity = (user: string) => {
        if (user.length > 2) {
            UserModel.getAdminAllSearch(user, this.setOptionCity, this.setError);
        }
    }


    @action 
    onChangeIsError=()=>{
        this.isErrorFilter = !this.isErrorFilter;
        this.reload();
    }

    @action
    onChangeInputCity = (e: ISelect) => {
        this.citySelected = e;
        this.cityError = '';
        this.pagination = {
            countPage: 1,
            countRow: 1,
            currentPage: 1
        }
        this.reload();
    }


    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    onCurrentPage = (page: number) => {
        this.pagination.currentPage = page;
        this.reload();
    }

    init = () => {
        this.arData = [];

        this.reload();
        // @ts-ignore
        this.rootStore?.pageRegEmployeeStore.falseRedirect();
        // @ts-ignore
        this.rootStore?.pageRegTradePointStore.falseRedirect();
    }

    @action
    reload() {
        LogModel.getAll(this.getModelData(), this.setData, this.setError);
    }

    @action
    setData = (result: any) => {
        result.data.rows.map((item: any) => {
            item.createdAt = new Date(item.createdAt);
            return item;
        });
        this.arData = result.data.rows;
        this.pagination = result.data.pagination;
    }

    @action setError = (error: any) => {
        console.log(error);
        // this.error = error.response.data.message;
    }

    @action onFilterUser = (e: any) => {
        this.search = e.target.value;
    }


    getModelData() {
        return {
            json: {
                limit: this.limitRow,
                filter: this.setFilter(),
            },
            page: this.pagination.currentPage
        };
    }

    setFilter = () => {
        let filter = {};
        if (this.citySelected.value) {
            // @ts-ignore
            filter['userId'] = this.citySelected.value;
        }
        if(this.isErrorFilter){
            // @ts-ignore
            filter['isError']=this.isErrorFilter;
        }
        return filter;
    }

    @action setOptionCity = (result: any) => {
        this.cityOption = [];
        this.cityError = '';
        result.data.rows.map((city: any) => {
            this.cityOption.push({
                label: city.name,
                value: city.id,
            });
        })
    }
}
